import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circle-cross",
  "use": "circle-cross-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"circle-cross\"><path d=\"M8 8.847l1.973 1.974a.6.6 0 00.848-.848L8.847 8l1.974-1.973a.6.6 0 00-.848-.848L8 7.153 6.027 5.179a.6.6 0 00-.848.848L7.153 8 5.179 9.973a.6.6 0 00.848.848L8 8.847z\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1 8a7 7 0 1014 0A7 7 0 001 8zm13 0A6 6 0 112 8a6 6 0 0112 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol